import script from "./TimeSlotItem.vue?vue&type=script&setup=true&lang=js"
export * from "./TimeSlotItem.vue?vue&type=script&setup=true&lang=js"

import "./TimeSlotItem.vue?vue&type=style&index=0&id=5008b34c&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5008b34c"]])

export default __exports__